import React from 'react';

import styles from './styles.module.scss';

const UTFooter = () => <div className={styles.footer} />;

export default UTFooter;
